module.exports = __webpack_public_path__ + "static/img/label-07.66e8b3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/flash/label-07.png
// module id = b9dU
// module chunks = 150